import React, { useState, useEffect } from "react";
import Player from "@vimeo/player";


export default function FloatingVideo() {
    const [showFloatingVideo, setShowFloatingVideo] = useState(true);
    const [isZoomed, setIsZoomed] = useState(false);

        useEffect(() => {
        const iframe = document.getElementById("vimeo-player-floating");
        if (iframe) {
            const player = new Player(iframe);

            const handleClick = () => {
                
                player.setVolume(1);
            };

            document.addEventListener("click", handleClick, { once: true });

            // Cleanup
            return () => {
                document.removeEventListener("click", handleClick);
            };
        }
    }, []);

    if (!showFloatingVideo) return null;

    const getDeviceType = () => {
        const width = window.innerWidth;

        if (width < 640) {
            return "mobile";   // sm
        } else if (width >= 640 && width < 1024) {
            return "tablet";   // md
        } else if (width >= 1024 && width < 1440) {
            return "laptop";   // lg
        } else if (width >= 1440 && width < 1920) {
            return "desktop";  // xl
        } else {
            return "large";    // 2xl+
        }
    };



    // Usage
    const deviceType = getDeviceType();

    return (
        <>
            {deviceType === "mobile" && isZoomed && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-70 z-[299] transition-opacity duration-300"
                    style={{ pointerEvents: "none" }}
                ></div>
            )}
            <div
                className={`fixed z-[300] rounded-lg overflow-hidden shadow-2xl  duration-500 
      ${isZoomed ? `top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
            ${window.innerWidth < 325 ? "w-[100vw] h-[22vh]" :
                            window.innerWidth > 325 && window.innerWidth < 425 ? "w-[80vw] h-[19vh]" : ""}`
                        : `bottom-4 right-4 ${deviceType === "mobile" ? "w-[160px] h-[100px]" :
                            deviceType === "tablet" ? "w-[320px] h-[180px]" :
                                deviceType === "laptop" ? "w-[420px] h-[280px]" :
                                    deviceType === "desktop" ? "w-[420px] h-[280px]" :
                                        "w-[560px] h-[360px]"}`}`}
            >

                <button
                    className={`absolute ${deviceType === "mobile" ? "top-0 right-[0]" : "top-0 right-[0]"} 
        text-white hover:text-gray-300 z-20 bg-gray-800 hover:bg-gray-900 
        rounded-full p-2 transition-all duration-200 shadow-lg`}
                    onClick={() => setShowFloatingVideo(false)}
                    aria-label="Close floating video"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>


                {deviceType === "mobile" && (
                    <button
                        className="absolute bottom-0 right-[0] text-white hover:text-gray-300
            z-20 bg-gray-800 hover:bg-gray-900 
            rounded-full p-2 transition-all duration-200 shadow-lg"
                        onClick={() => setIsZoomed(!isZoomed)}
                        aria-label="Zoom video"
                    >
                        {isZoomed ? (
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8h16M4 16h16" />
                            </svg>
                        ) : (
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z" />
                            </svg>
                        )}
                    </button>
                )}



                <div className="relative w-full h-full">
                    <iframe
                        id="vimeo-player-floating"
                        className="w-full h-full"
                        src="https://player.vimeo.com/video/1108567199?autoplay=1&muted=1&controls=1&title=0&byline=0&portrait=0&dnt=1"
                        title="Watch & Learn: Full Game Walkthrough"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </>
    );
}
